import { Routes } from '@angular/router';
import { LayoutComponent } from '@app/components/layout/layout.component';
import { authGuard } from '@app/core/guards/auth.guard';
import { ComingSoonComponent } from '@app/shared/components/coming-soon/coming-soon.component';
import { roleGuard } from '@app/core/guards/role.guard';
import { functionGuard } from '@app/core/guards/function.guard';
import { RoleName } from '@app/shared/enums/user.enum';
import { RoleFunctionName } from '@app/core/enums/role-function-name.enum';
import { isUserFullyRegisteredGuard } from '@app/core/guards/is-user-fully-registered.guard';
import { nonAuthGuard } from '@app/core/guards/non-auth.guard';
import { InstructionsComponent } from '@app/pages/instructions/instructions.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full'
      },
      {
        path: 'main',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            m => m.DashboardComponent
          ),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      // {
      //   path: 'consulting',
      //   loadChildren: () =>
      //     import('./pages/ai-consulting/ai-consulting.routes').then(
      //       m => m.routes
      //     ),
      //   canActivate: [authGuard, isUserFullyRegisteredGuard]
      // },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/notifications/notifications.component').then(
            m => m.NotificationsComponent
          ),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('./pages/analytics/analytics.routes').then(m => m.routes),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'procurement',
        loadChildren: () =>
          import('./pages/procurement/procurement.routes').then(m => m.routes),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'sales',
        component: ComingSoonComponent,
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'commercial-documents',
        loadChildren: () =>
          import(
            './pages/commercial-documents/commercial-documents.routes'
          ).then(m => m.routes),
        canActivate: [
          authGuard,
          isUserFullyRegisteredGuard,
          roleGuard([RoleName.Approver, RoleName.Buyer]),
          functionGuard([
            RoleFunctionName.AgreementsViewOwn,
            RoleFunctionName.AgreementsViewAll
          ])
        ]
      },
      {
        path: 'tasks',
        loadChildren: () =>
          import('./pages/tasks/tasks.routes').then(m => m.routes),
        canActivate: [
          authGuard,
          isUserFullyRegisteredGuard,
          functionGuard([RoleFunctionName.ApprovalViewTask])
        ]
      },
      {
        path: 'marketplace',
        component: ComingSoonComponent,
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'company',
        loadChildren: () =>
          import('./pages/company/company.routes').then(m => m.routes),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'administration',
        loadChildren: () =>
          import('./pages/administration/administration-routing.routes').then(
            m => m.routes
          ),
        canActivate: [
          authGuard,
          isUserFullyRegisteredGuard,
          roleGuard([]),
          functionGuard([
            RoleFunctionName.AdminView,
            RoleFunctionName.AdminEdit
          ])
        ]
      },
      {
        path: 'constructor',
        loadChildren: () =>
          import('./pages/constructor/constructor.module').then(
            m => m.ConstructorModule
          ),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'help',
        loadChildren: () =>
          import('./pages/help/help.module').then(m => m.HelpModule),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'new',
        loadChildren: () =>
          import('./pages/new/new.module').then(m => m.NewModule),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'not-access',
        loadComponent: () =>
          import('./pages/not-access/not-access.component').then(
            m => m.NotAccessComponent
          ),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./pages/reports/reports.routes').then(m => m.routes),
        canActivate: [authGuard, isUserFullyRegisteredGuard]
      }
    ]
  },
  {
    path: 'frames',
    loadChildren: () =>
      import('./pages/frames/frames.routes').then(m => m.routes)
  },
  {
    path: 'instructions',
    component: InstructionsComponent
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/signup/signup.component').then(m => m.SignupComponent),
    canActivate: [nonAuthGuard]
  },
  {
    path: 'signin',
    loadComponent: () =>
      import('./pages/signin/signin.component').then(m => m.SigninComponent),
    canActivate: [nonAuthGuard]
  },
  {
    path: 'resetpassword',
    loadComponent: () =>
      import('./pages/reset-password/reset-password.component').then(
        m => m.ResetPasswordComponent
      ),
    canActivate: [nonAuthGuard]
  },
  {
    path: '**',
    redirectTo: 'main'
  }
];
